/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Close_ShortInputs */

const en_us2_search_close_short = /** @type {(inputs: Search_Close_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const pt_br2_search_close_short = /** @type {(inputs: Search_Close_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

const es_419_search_close_short = /** @type {(inputs: Search_Close_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar`)
};

const pt_pt2_search_close_short = /** @type {(inputs: Search_Close_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

const fr_fr2_search_close_short = /** @type {(inputs: Search_Close_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const de_de2_search_close_short = /** @type {(inputs: Search_Close_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const it_it2_search_close_short = /** @type {(inputs: Search_Close_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Search_Close_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_close_short = /** @type {((inputs?: Search_Close_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Close_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_close_short(inputs)
	if (locale === "es-419") return es_419_search_close_short(inputs)
	if (locale === "pt-PT") return pt_pt2_search_close_short(inputs)
	if (locale === "fr-FR") return fr_fr2_search_close_short(inputs)
	if (locale === "de-DE") return de_de2_search_close_short(inputs)
	if (locale === "it-IT") return it_it2_search_close_short(inputs)
	return en_us2_search_close_short(inputs)
});
export { search_close_short as "search.close_short" }